/* ONE SIZE — modulo "Avvisami" con consenso marketing esplicito.
   1) Invia il modulo cliente di Shopify (crea il cliente iscritto al marketing con i tag avvisami-<handle>).
   2) Se l'email è già di un cliente esistente Shopify non aggiorna i tag: la richiesta viene inoltrata
      al negozio con il modulo contatti, così non va persa. */
(function () {
  'use strict';
  function $(s, r) { return (r || document).querySelector(s); }
  function post(form) {
    return fetch(form.getAttribute('action') || '/contact', { method: 'POST', body: new FormData(form), credentials: 'same-origin', headers: { Accept: 'text/html' } });
  }
  function variantLabel() {
    var vals = [];
    document.querySelectorAll('variant-selects input:checked, variant-selects select').forEach(function (el) { if (el.value) vals.push(el.value); });
    return vals.join(' / ');
  }
  function stamp() {
    try { return new Date().toLocaleString('it-IT', { timeZone: 'Europe/Rome' }); } catch (e) { return new Date().toISOString(); }
  }
  function success(box, form) {
    var msg = document.createElement('p'); msg.className = 'os-popup__ok os-notify__ok'; msg.setAttribute('role', 'status');
    msg.textContent = box.dataset.success || 'Sei nella lista!';
    form.replaceWith(msg);
  }
  function init(box) {
    var form = $('[data-os-notify-form]', box); if (!form || form.dataset.osNotify) return; form.dataset.osNotify = '1';
    var backup = $('[data-os-notify-backup]', box), err = $('[data-os-notify-error]', box);
    var consent = $('input[name="contact[accepts_marketing]"]', form);
    if (consent) {
      var m = 'Per ricevere l’avviso spunta la casella del consenso.';
      consent.addEventListener('invalid', function () { consent.setCustomValidity(consent.checked ? '' : m); });
      consent.addEventListener('change', function () { consent.setCustomValidity(''); });
    }
    form.addEventListener('submit', function (e) {
      if (!window.fetch || !window.FormData) return; /* invio classico */
      e.preventDefault();
      if (form.reportValidity && !form.reportValidity()) return;
      var btn = $('button[type="submit"]', form), label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Invio…'; }
      if (err) err.hidden = true;
      var email = ($('input[type="email"]', form).value || '').trim();
      post(form).then(function (r) {
        var url = r.url || '';
        if (/\/challenge/.test(url)) { HTMLFormElement.prototype.submit.call(form); return; }
        if (/customer_posted=true/.test(url)) { success(box, form); return; }
        if (!backup) { success(box, form); return; }
        var h = box.dataset.product, v = variantLabel();
        $('[name="contact[email]"]', backup).value = email;
        $('[name="contact[body]"]', backup).value = [
          'Richiesta AVVISAMI da un cliente già registrato (Shopify non aggiorna i clienti esistenti dal modulo del sito).',
          '',
          'Email: ' + email,
          'Prodotto: ' + (box.dataset.title || h) + (v ? ' — ' + v : ''),
          'Link: ' + location.origin + '/products/' + h,
          'Consenso marketing: SÌ, casella spuntata il ' + stamp(),
          'Testo del consenso: "' + (box.dataset.consent || '') + '"',
          '',
          'Per attivare l’avviso automatico (30 secondi):',
          '1) Shopify > Clienti > cerca ' + email,
          '2) Aggiungi il tag: avvisami-' + h,
          '3) Se non risulta "Iscritto" al marketing via email, modifica le impostazioni di marketing e iscrivilo (il cliente ha dato il consenso).',
          'Al ritorno in magazzino il Flow "OneSize - Avvisami" invierà l’email in automatico.'
        ].join('\n');
        return post(backup).then(function (r2) {
          if (r2 && /\/challenge/.test(r2.url || '')) { HTMLFormElement.prototype.submit.call(backup); return; }
          success(box, form);
        });
      }).catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = label; }
        if (err) { err.textContent = 'Si è verificato un errore. Riprova tra qualche istante.'; err.hidden = false; }
      });
    });
  }
  function run() { document.querySelectorAll('[data-os-avail]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
